import { MARQUEE } from "./data";

export const Marquee = ({ items = MARQUEE }) => {
  const list = [...items, ...items];
  return (
    <section data-testid="marquee-section" className="relative py-12 border-y border-[#1c1c1c] bg-[#050505] overflow-hidden">
      <div className="sa-marquee-track">
        {list.map((word, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-display font-light text-3xl md:text-5xl text-[#2a2a2a] px-10">{word}</span>
            <span className="h-2 w-2 rounded-full bg-[#fcc41b]/40" />
          </span>
        ))}
      </div>
    </section>
  );
};
